import { defineMessages } from 'react-intl';

const localMessages = defineMessages({
  project_principals: '项目负责人',
  priority: '需求优先级',
  expect_end_at: '需求执行预计结束日期',
  plan_type: '策划类型',
  categories: '需求类型',
  project_planners: '策划',
  budget_short: '预算',
  ad_settle_way: '报价方式',
  plan_attachs: '策划案',
  purchase_attachs: '采购清单',
  reference_attachs: '参考内容',
  superior_resource_id: '合作平台',
  quote_price: '报价金额',
  quote_price_rmb: '报价金额',
  program_desc: '方案说明',
  currency: '币种',
  quote_price_total: '报价总金额',
  quote_price_origin: '变更前报价金额',
  quote_price_changed: '变更后报价金额',
  requoteNote: '变更说明',
  index: '序号',
  account: '需求合作内容',
  remark: '备注',
  evaluate_scores: '服务评分',
  settle_price: '最终结算金额',
  settle_report_attachs: '结案报告',
  bid_attachs: '供应商比选方案及相关文件',
  advance_info: '付款账号信息',
  source_id: '关联原MPC单号',
});

const messages = {
  ...localMessages,
};

export default messages;
